export const rules = {
    skill: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
};
